import { Typography } from "src/components/shared";
import { MoveUpRight } from "lucide-react";

export const SummitLocationList = ({ content }: { content: any }) => {
    const listOfLocation = content?.listOfLocationCollection?.items ?? [];
    
    return (
      <div className="summit-event-content">
        {listOfLocation.map((item, index) => (
          <div key={index} className="summit-event-content-item">
            <div className="summit-event-side-by-side">
              <img src={item?.icon?.linkIcon?.url} alt={item?.icon?.linkText || ""} />
              <Typography tag="h4">{item.title}</Typography>
            </div>
            <div className="summit-separator"></div>
            {index === 0 ? (
              <div className="summit-event-side-by-side">
                <Typography tag="p" className="grey-medium-dark mx-w-450 mb-20">
                  {item.information}
                </Typography>
                <MoveUpRight size={16} />
              </div>
            ) : (
              <Typography tag="p" className="grey-medium-dark mx-w-450 mb-20">
                {item.information}
              </Typography>
            )}
          </div>
        ))}
      </div>
    );
  };